export default __webpack_public_path__ + "static/media/image003.20ab8ca9.jpg";